<template>
	<div class="collect-page collect-card">
		<div class="mains-content">
			<div class="page-left">
				<div class="member-box"><member ref="member" :mobile="formMobile" @handleChange="memberChange"></member></div>
				<div class="right-box">
					<div v-if="list.length == 0 ? true : false" class="right-box-empty">
						<div class="right-box-empty-img">
							<img src="../../../assets/images/new/fooBath_empty.png" alt="" />
						</div>
					</div>
					<div v-else>
						<div class="contents-body">
							<div class="title-tabs">
								<p class="order-title-boxs mt0 pt30"><span class="blueBlock"></span><i>请选择充值金额</i></p>
								<div class="card-boxs">
									<div
										class="card-box"
										:class="item.show ? 'active' : ''"
										v-for="(item, index) in list"
										:key="index"
										@click="handleChangeList(item, index)"
									>
										<div class="card-msg">
											<p class="money">{{ item.rechargeAmount }}元</p>
											<p class="fontSize14 color666 pt10">{{ item.remark }}</p>
										</div>
										<div class="payCheak" v-if="item.show"><img src="../../../assets/images/new/payRadio.png" alt="" /></div>
									</div>
									<div class="custom-box w100b">
										<div>充值金额</div>
										<el-input v-model.trim="toUpMoney" maxlength="8" placeholder="请输入金额" @input="changeMoney" class="textRight">
											<!-- <span slot="prefix">元</span> -->
										</el-input>
										<p class="text">元</p>
									</div>
									<div class="custom-box w100b" style="margin-top: 10px;" v-if="isShowGiveAmount">
										<div>赠送金额</div>
										<el-input
											v-model="form.giveAmount"
											maxlength="8"
											placeholder="请输入赠送金额"
											:disabled="!canModifyGiveAmount"
											class="textRight"
										>
											<!-- <span slot="prefix">元</span> -->
										</el-input>
										<p class="text">元</p>
									</div>
								</div>
								<div class="staff-boxs mt60">
									<p class="order-title-boxs"><span class="blueBlock"></span><i>请选择服务技师</i></p>
									<div class="right-content flex-row">
										<span class="staff-btn mr10">服务技师：</span>
										<span class="jishi cur" @click="setStaff('item', 0)">{{ staffName ? staffName : '请选择' }}></span>
									</div>
								</div>
								<div class="payWayClass">
									<v-payment :member="false" :reset="resetFlag" @payMentFun="paymentChange" data="recharge"></v-payment>
								</div>
							</div>
							<div class="confirm-btn">
								<div class="flex-row space-between">
									<div class="msg">
										<!-- <div class="nums total">
                      赠送金额:
                      <span class="moneys fontSize20">￥<span class="fontSize28 fb">{{ form.giveAmount || 0}}</span></span>
                    </div> -->
										<div class="total">
											充值金额:
											<span class="moneys fontSize20"
												>￥<span class="fontSize28 fb">{{ totalAmount }}</span></span
											>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<el-button class="save_btn" @click="saveMoney">确定开单</el-button>
			</div>
			<div class="left-box br10">
				<div class="cardFlex">
					<img src="../../../assets/images/new/recharge.png" alt="" />
					<div class="pt24 fontSize16 color999">暂无其他内容</div>
				</div>
				<tips :type="'member'" class="tips-position"></tips>
			</div>
		</div>
		<staff-set ref="staffSetForm" :isCashier="true" @staffChange="changePage"></staff-set>
		<confimDdialog
			ref="confimFrom"
			@handleChange="confirmMoney"
			:money="money"
			:payWay="form.payWay"
			:payWayDescription="form.payWayDescription"
		></confimDdialog>
		<pay-form ref="payEditForm" @payFun="payMoney" @rePay="refreshToken" :source="'topUp'" :noPay="false" :amount="Number(money)" :foot="true"></pay-form>
	</div>
</template>

<script>
import minxin from '../../../assets/javascript/minxin.js'
import staffSet from '../../components/staff-set'
import member from '../../components/member'
import tips from '../../../components/tips'
import confimDdialog from '../../components/confim-dialog'
import payForm from '../../components/pay'
import { encrypt } from '../../../assets/javascript/untils'
import { Loading } from 'element-ui'
export default {
	mixins: [minxin],
	components: { staffSet, member, tips, confimDdialog, payForm },
	data() {
		return {
			addEditTitle: '会员充值',
			toUpMoney: '',
			totalAmount: 0,
			list: [],
			listSelected: [],
			form: {
				memberId: '',
				orderId: '',
				staffIds: '',
				amount: '',
				orderId: '',
				payWay: '',
				payWayDescription: '',
				verifyCode: '',
				payCheckType: '',
				rechargeAmount: '',
        giveAmount: '',
        repeatToken: '',
			},
			amountForm: {},
			clearTime: null,
			staffIds: {},
			staffName: '',
			firststaff: [],
			money: 0,
			formMobile: '',
			resetFlag: false,
			isSacn: false,
			canModifyGiveAmount: false,
			isShowGiveAmount: false,
		}
	},
	created() {
    this.getPriceList()
	},
  mounted () {
    this.getToken()
  },
	destroyed() {},
	methods: {
		getPriceList() {
			// 获取列表
			this.$api.post(this.$url.order.listRechargeItem).then((res) => {
				res.map((item, index) => {
					item.show = false
					item.staffIds = []
				})
				this.list = res
				if (res.length > 0) {
					this.isShowGiveAmount = res[0].customRuleFlag == 'yes'
				}
			})
		},
		payMoney(org) {
			console.log('org: ', org)
			if (org) {
				this.$refs.member.clearMember()
				this.totalAmount = 0
				this.toUpMoney = ''
				this.giveUpAmount = ''
				this.staffName = ''
				this.resetFlag = true
				this.list.map((item) => {
					item.show = false
				})
				if (this.$refs['confimFrom']) this.$refs['confimFrom'].dialogCashFlag = false
				console.log(this.$refs['confimFrom'], '----------')
			}
			this.isSacn = false
		},
		handleChangeList(item, index) {
			this.money = item.money
			this.listSelected = []
			this.toUpMoney = ''
			this.giveUpAmount = ''
			this.totalAmount = item.rechargeAmount
			this.form.giveAmount = item.giveAmount
			this.canModifyGiveAmount = item.updateGiveAmountFlag == 'yes'
			this.listSelected.push(item)
			if (this.staffIds.staffIds) {
				this.$set(this.listSelected[this.staffIds.nodeId], 'staffIds', this.staffIds.staffIds)
			} else {
				this.staffName = ''
			}
			for (let i in this.list) {
				this.$set(this.list[i], 'show', false)
			}
			this.$set(this.list[index], 'show', true)
		},
		changeMoney() {
			if (this.clearTime) {
				clearTimeout(this.clearTime)
			}
			// this.toUpMoney = this.bigNum(this.toUpMoney)
			this.toUpMoney = this.isMoneyTwo(this.toUpMoney)
			if (this.toUpMoney) {
				let index = 0
				for (let i = 0; i < this.list.length; i++) {
					if (Number(this.list[i].rechargeAmount) > this.toUpMoney) {
						index = i > 0 ? i - 1 : i
						break
					}
					if (Number(this.list[i].rechargeAmount) <= this.toUpMoney && i == this.list.length - 1) {
						index = this.list.length - 1
					}
				}
				if (index == 0 && Number(this.list[index].rechargeAmount) > this.toUpMoney) {
					this.form.giveAmount = 0
					this.canModifyGiveAmount = false
				} else {
					this.form.giveAmount = this.list[index].giveAmount
					this.canModifyGiveAmount = this.list[index].updateGiveAmountFlag == 'yes'
				}
			} else {
				this.form.giveAmount = 0
			}
			this.totalAmount = Number(this.toUpMoney)
			this.money = this.toUpMoney
			if (Number(this.toUpMoney) == 0) {
				this.$message.warning('请输入或选择金额')
				this.listSelected = []
			} else {
				this.listSelected = []
				this.listSelected.push({
					rechargeAmount: Number(this.toUpMoney),
					giveAmount: this.form.giveAmount,
					staffIds: [],
					show: false,
				})

				if (this.staffIds.staffIds) {
					this.$set(this.listSelected[this.staffIds.nodeId], 'staffIds', this.staffIds.staffIds)
				} else {
					this.staffName = ''
				}
				for (let i in this.list) {
					this.$set(this.list[i], 'show', false)
				}
			}
		},
		paymentChange(item) {
			console.log(item)
			this.form.payWay = item.payCode
			this.form.payWayDescription = item.payName
			this.resetFlag = false
		},
		changePage(org) {
			if (org && org.staffIds) {
				let arr = []
				org.staffIds.map((item) => {
					arr.push(item.staffName)
				})
				this.staffName = arr.join(',') + '>'
				this.staffIds = org
				if (this.listSelected.length > 0) {
					this.$set(this.listSelected[org.nodeId], 'staffIds', org.staffIds)
				}
			}
		},
		setStaff(row, index) {
			this.$refs['staffSetForm'].$emit('set', {
				staffIds: row.staffIds,
				index: index,
			})
		},
		memberChange(value) {
			if (value == '') {
				for (let i in this.list) {
					this.$set(this.list[i], 'staffIds', [])
				}
				this.listSelected = []
			}
			this.form.memberId = value
		},
		saveMoney() {
			if (this.isSacn) return
			if (this.form.memberId == '') {
				this.$message.warning('请选择会员')
				return false
			}
			console.log('aa', this.list)

			if (this.form.payWay == '') {
				this.$message.warning('请选择支付方式')
				return false
			}
			if (this.listSelected.length < 1) {
				this.$message.warning('请添加充值金额')
				return false
			} else if (!this.listSelected[0].rechargeAmount) {
				this.$message.warning('充值金额不能为0')
				return false
			} else if (!/^(([1-9]{1}\d*)|(0))(\.\d{1,2})?$/.test(this.listSelected[0].rechargeAmount)) {
				this.$message.warning('请输入正确的金额数字，最多两位小数')
				return false
			}

			for (let i in this.listSelected) {
				if (this.listSelected[i].staffIds.length < 1) {
					this.$message.warning('请选择技师')
					return false
				}
			}
			let arrIds = '',
				arrNames = ''
			for (let i in this.listSelected) {
				for (let j in this.listSelected[i].staffIds) {
					if (j == 0) {
						arrIds = this.listSelected[i].staffIds[j].staffId
						arrNames = this.listSelected[i].staffIds[j].staffName
					} else {
						arrIds += ',' + this.listSelected[i].staffIds[j].staffId
						arrNames += ',' + this.listSelected[i].staffIds[j].staffName
					}
				}
			}
			this.form.staffIds = arrIds
			this.form.staffNames = arrNames
			this.form.amount = this.listSelected[0].rechargeAmount
			this.money = this.listSelected[0].rechargeAmount
			this.$refs['confimFrom'].inits('member')
		},
		confirmMoney(val) {
			console.log('进入这里')
			console.log(val)
			if (val) {
				this.form.payCode = val
				const loadingInstance = Loading.service({
					lock: true,
					background: 'rgba(0, 0, 0, 0.7)',
				})
				console.log(this.form)
				this.form.millisecond = new Date().getTime()

				this.$api.post(this.$url.order.recharge, encrypt(JSON.stringify(this.form))).then((res) => {
					console.log('进入这里1', res)

					if (res && res.status == 'fail') {
						let parmar = {
							orderId: res,
							payWay: this.form.payWay,
							queryFlag: false,
							close: true,
							closeMessage: res.message,
						}
						loadingInstance.close()
						this.$refs['payEditForm'].$emit('set', parmar)
						return
					}

					if (res) {
						console.log('进入这里2')
						if (this.form.payWay == 'tonglianStore' || this.form.payWay == 'yinlianStore') {
							this.isSacn = true
							let parmar = {
								orderId: res,
								payWay: this.form.payWay,
								queryFlag: true,
							}
							loadingInstance.close()
							this.$refs['payEditForm'].$emit('set', parmar)
							return
						} else {
							loadingInstance.close()
							this.$message.success('支付成功')
						}
						loadingInstance.close()
						this.$refs.member.clearMember()
						this.totalAmount = 0
						this.toUpMoney = ''
						this.staffName = ''
						this.staffIds = {}
						this.listSelected = []
						this.form.giveAmount = ''
						this.resetFlag = true
						this.list.map((item) => {
							item.show = false
						})
					}

          if (!res) {
            loadingInstance.close()
            this.getToken()
          }
				})
			} else {
				console.log('2')
				this.isSacn = false
			}
		},
		deleteListSelected(item, index) {
			this.listSelected.splice(index, 1)
			for (let i in this.list) {
				this.$set(this.list[i], 'show', false)
			}
		},
		refreshToken() {
			this.isSacn = false
			this.getToken()
    },
    getToken () { 
      this.$api.get(this.$url.order.getToken).then((res) => {
				if (res) {
					this.form.repeatToken = res
				}
			})
    },
	},
}
</script>

<style scoped lang="less">
@import '../../../assets/css/edit.less';
.block {
	width: 100%;
	.card_active {
		position: absolute;
		top: 0;
		right: 0;
		width: 30px;
		height: 30px;
	}
}
.cardFlex {
	height: calc(100vh - 200px);
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #999;
}
.staff-boxs {
	.right-content {
		padding: 0 24px 24px;
		box-sizing: border-box;
		.staff-btn {
			display: inline-block;
			font-size: 16px;
			text-align: center;
			color: #111;
		}
	}
}
.title-tabs {
	height: calc(100vh - 330px);
	overflow: auto;

	.card-boxs {
		padding: 0 24px;
		display: flex;
		flex-wrap: wrap;
		.card-box {
			width: calc(32% - 2px);
			height: 102px;
			margin-right: 2%;
			margin-bottom: 16px;
			position: relative;
			background: #f2f3f5;
			border: 1px solid #f2f3f5;
			border-radius: 4px;
			&:nth-of-type(3n) {
				margin-right: 0;
			}
			.card-msg {
				height: 102px;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				font-size: 30px;
				font-weight: 700;
				.card-name {
					font-size: 18px;
					font-weight: 700;
				}
				.msg {
					text-align: left;
				}
			}
		}
		.active {
			background: #eaf4fe;
			border: 1px solid #3388ff;
		}
	}
}
.mains-content {
	display: flex;
	height: 100%;
	.left-box {
		width: 60%;
		background-color: #fff;
		display: flex;
		flex-direction: column;
		overflow: hidden;
		position: relative;
		.tips-position {
			position: absolute;
			width: calc(100% - 74px);
			bottom: 16px;
		}
	}
}
.collect-card {
	height: calc(100vh - 58px);
	background-color: #e6edf5;
	padding: 16px;
	.groupDialog /deep/ .el-dialog__body {
		padding: 10px 20px;
		color: #111;
		height: 200px;
		overflow: auto;
	}
}
.box-active {
	height: 435px !important;
}
.member-box {
	width: calc(100% - 48px);
	padding: 15px 16px;
	background: #3388ff;
	border-radius: 10px 10px 0px 0px;
}
.right-box {
	position: relative;
	background: url('../../../assets/images/new/footBath.png') no-repeat;
	background-position: center bottom;
	height: calc(100vh - 248px);
	margin-right: 16px;
	.right-box-empty {
		height: calc(100vh - 248px);
		display: flex;
		justify-content: center;
		align-items: center;
		.right-box-empty-img {
			width: 191px;
			height: 170px;
		}
	}
	.shoping-titles {
		padding: 16px;
		font-size: 18px;
		font-weight: 700;
	}
	.contents-body {
		.confirm-btn {
			position: absolute;
			bottom: 0;
			width: calc(100% - 32px);
			display: flex;
			align-items: center;
			margin: 0 16px;
			border-top: 1px solid #ebedf0;
			padding: 12px 0;
			.flex-row {
				width: 100%;
				align-items: center;

				.msg {
					width: 100%;
					display: flex;
					justify-content: flex-end;
					font-weight: 500;
					.nums {
						margin-right: 40px;
					}
				}
			}
		}
	}
}
.page-left {
	width: 40%;
	position: relative;
}
.box-actives {
	border: 1px solid #f9aa6c !important;
}
.save_btn {
	width: calc(100% - 16px);
	height: 68px;
	font-size: 20px;
	font-weight: bold;
	margin-top: 15px;
	color: #fff;
	background: #ff5449;
}
.goodName {
	width: 150px;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
}
/deep/ .el-input__prefix {
	color: #111;
	display: flex;
	align-items: center;
	font-size: 16px;
}
.custom-box {
	width: 100%;
	font-size: 18px !important;
	border: 1px solid #dcdee0;
	border-radius: 4px;
	display: flex;
	height: 48px;
	align-items: center;
	padding: 0 16px;
	/deep/.el-input {
		flex: 1;
		.el-input__inner {
			border: 0;
			font-size: 18px !important;
		}
	}
}
.payCheak {
	width: 30px;
	height: 30px;
	position: absolute;
	top: 0;
	right: 0;
}
/deep/ .textRight .el-input__inner {
	text-align: right !important;
}
</style>
